export default {
  'global.contract_not_bound': 'Pending Contract Confirmation',
  'global.returnHome' : 'Return to Home',
  'global.name': 'Name',
  'global.description': 'Description',
  'global.updatedtime': 'Updated time',
  'global.createdtime': 'Created time',
  'global.new': 'New',
  'global.searchText': 'Search',
  'global.resetText': 'Reset',
  'global.operation': 'Operation',
  'global.confirmDelete': 'Delete this item?',
  'global.confirm': 'Confirm',
  'global.cancel': 'Cancel',
  'global.save': 'Save',
  'global.update': 'Update',
  'global.delete': 'Delete',
  'global.company': 'Company',
  'global.partner': 'Partner',
  'global.email': 'Email',
  'global.customer': 'Customer',
  'global.rank': 'Rank',
  'global.country': 'Country',
  'global.download': 'Download',

  //-- 产品相关指标多语言
  'global.dau': 'DAU',
  'global.mau': 'MAU',
  'global.totalUsers': 'Total Users',
  'global.totalPlayDuration': 'Total Play Duration',
  'global.playDuration': 'Play Duration(h)',
  'global.totalPlayCount': 'Total Play Count',
  'global.playCount': 'Play Count',
  'global.totalPlayUsers': 'Total Play Users',
  'global.playUsers': 'Play Users',
  'global.dailyActiveUsers': 'Daily Active Users',
  'global.averageActiveUsers': 'Average Active Users',
  'global.totalContentDeeplinkClick': 'Deeplink Clicks',
  'global.top10DeeplinkContents': 'Top 10 Deeplink Contents',
  'global.top10ChannelsPreferredByUsers': 'The 10 Channels Most Preferred By Users',
  'global.avgEngagementTimePerActiveUser': 'Average Engagement Time Per Active User',
  'global.usersByTop10Countries': 'Users By Top 10 Countries',
  'global.revenueByTop10Countries': 'Revenue By Top 10 Countries',
  'global.totalAppUsageTime': 'Total App Usage Time',
  'global.top10CustomerRevenue': 'Top 10 Customer Revenue',
  'global.image': 'Image',
  'global.title': 'Title',
  'global.category': 'Category',
  'global.trend': 'Trend',
  'global.channelAnalytics': 'Channel Analytics',
  'global.dimensions': 'Dimensions',
  'global.metrics': 'Metrics',
  'global.filters': 'Filters',
  'global.channelName': 'Channel Name',
  'global.channelCategory': 'Channel Category',

  //-- 广告相关指标多语言
  'global.adIndex': 'Ad Index',
  'global.adRequests': 'Ad Requests',
  'global.impressions': 'Impressions',
  'global.ecpm': 'eCPM($)',
  'global.ecpmRevenue': 'eCPM Revenue($)',
  'global.nonEcpmRevenue': 'Non-eCPM Revenue($)',
  'global.totalRevenue': 'Total Revenue($)',
  'global.netRevenue': 'Net Revenue($)',
  'global.grossRevenue': 'Gross Revenue($)',

  //-- 时间相关多语言
  'global.customDateRange': 'Custom Date Range',
  'global.yesterday': 'Yesterday',
  'global.last7days': 'Last 7 Days',
  'global.last14days': 'Last 14 Days',
  'global.thisMonth': 'This Month',
  'global.lastMonth': 'Last Month',
  'global.last3Month': 'Last 3 Months',
  'global.last6Month': 'Last 6 Months',
  'global.last12Month': 'Last 12 Months',
  'global.day': 'Day',
  'global.week': 'Week',
  'global.month': 'Month',
  'global.year': 'Year',
  'global.date': 'Date',


};
